import { cn } from "@/lib/utils";

type SliderWordmarkProps = {
  className?: string;
};

export function SliderWordmark({ className }: SliderWordmarkProps) {
  return (
    <span
      className={cn(
        "text-foreground inline-flex items-baseline font-sans text-xl font-semibold tracking-tight select-none",
        className,
      )}
    >
      Slider
      <span aria-hidden="true" className="bg-slider-coral ml-px inline-block h-[0.2em] w-[0.2em]" />
    </span>
  );
}
